import React, { useState } from "react"
import { Formik, Form, ErrorMessage } from "formik"
import * as Yup from "yup"

import { Label, Input, StyledInlineErrorMessage, Submit, Field } from "./style"
import { navigateTo, Link } from "gatsby"

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Please enter your name")
    .required("Please enter your name"),
  email: Yup.string()
    .email("The email address doesn't look correct")
    .required("Please enter your email address"),

  message: Yup.string()
    .min(10, "Please enter your message")
    .required("Please enter your message"),

  privacyPolicy: Yup.bool().oneOf([true], "Please accept our privacy policy"),

  sentFromUrl: Yup.string(),
})

// function to help format for netlify form
const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const ContactForm = props => {
  const [] = useState()
  const url = typeof window !== "undefined" ? window.location.href : ""

  return (
    <Formik
      initialValues={{
        name: "",
        email: "",
        phone: "",
        message: "",
        privacyPolicy: false,
        sentFromUrl: url,
      }}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({ "form-name": "contact", ...values }),
        })
          .then(() => {
            navigateTo(props.firmName + "/contact-success")
            actions.resetForm()
          })
          .catch(() => {
            alert("Sorry, it looks like something went wrong...")
          })
          .finally(() => actions.setSubmitting(false))
      }}
    >
      {({
        values,
        errors,
        touched,
        handleSubmit,
        isSubmitting,
        isValidating,
        isValid,
      }) => {
        return (
          <>
            <Form
              name="contact"
              method="post"
              data-netlify="true"
              netlify-honeypot="bot-field"
              action="/contact-success"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="bot-field" />
              <Label htmlFor="name">
                Name
                <Input
                  type="text"
                  name="name"
                  autoCorrect="off"
                  autoComplete="name"
                  placeholder="Your name..."
                  valid={touched.name && !errors.name}
                  error={touched.name && errors.name}
                />
              </Label>
              {errors.name && touched.name && (
                <StyledInlineErrorMessage>
                  {errors.name}
                </StyledInlineErrorMessage>
              )}
              <Label htmlFor="email">
                Email
                <Input
                  type="email"
                  name="email"
                  autoCapitalize="off"
                  autoCorrect="off"
                  autoComplete="email"
                  placeholder="Your email address..."
                  valid={touched.email && !errors.email}
                  error={touched.email && errors.email}
                />
              </Label>
              <ErrorMessage name="email">
                {msg => (
                  <StyledInlineErrorMessage>{msg}</StyledInlineErrorMessage>
                )}
              </ErrorMessage>
              <Label htmlFor="phone">
                Phone
                <Input
                  type="tel"
                  name="phone"
                  autoCapitalize="off"
                  autoCorrect="off"
                  placeholder="Your phone number..."
                  valid={touched.phone && !errors.phone}
                  error={touched.phone && errors.phone}
                />
              </Label>
              <ErrorMessage name="phone">
                {msg => (
                  <StyledInlineErrorMessage>{msg}</StyledInlineErrorMessage>
                )}
              </ErrorMessage>
              <Label htmlFor="message">
                Message
                <Field
                  component="textarea"
                  rows="3"
                  name="message"
                  autoCorrect="off"
                  placeholder="Your message..."
                  valid={touched.message && !errors.message}
                  error={touched.message && errors.message}
                />
              </Label>
              {errors.message && touched.message && (
                <StyledInlineErrorMessage>
                  {errors.message}
                </StyledInlineErrorMessage>
              )}

              <Label htmlFor="privacyPolicy">
                <Input
                  type="checkbox"
                  name="privacyPolicy"
                  className="checkbox"
                  valid={touched.privacyPolicy && !errors.privacyPolicy}
                  error={touched.privacyPolicy && errors.privacyPolicy}
                />
                <div style={{ display: "inline-block" }}>
                  {" "}
                  I agree to the{" "}
                  <Link to={props.firmName + "/privacy-policy"}>
                    privacy policy
                  </Link>
                </div>
              </Label>
              <ErrorMessage name="privacyPolicy">
                {msg => (
                  <StyledInlineErrorMessage>{msg}</StyledInlineErrorMessage>
                )}
              </ErrorMessage>
              <Field type="hidden" name="sentFromUrl" value={url}></Field>
              <Submit type="submit" disabled={!isValid || isSubmitting}>
                {isSubmitting ? `Submiting...` : `Submit`}
              </Submit>
            </Form>
          </>
        )
      }}
    </Formik>
  )
}

export default ContactForm
